var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselTicketBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 323,
    viewBox: "0 0 199 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.608 7.39683e-06C192.527 7.74229e-06 198.946 6.407 198.946 14.3104L198.946 307.754C198.946 315.657 192.527 322.064 184.608 322.064H133.637C126.66 313.535 114.446 307.882 100.544 307.882C86.6432 307.882 74.4291 313.535 67.4515 322.064H14.3385C6.41956 322.064 -3.46147e-07 315.657 0 307.754L1.44825e-05 14.3104C1.48287e-05 6.40702 6.41956 -3.4547e-07 14.3385 0L67.4514 2.95873e-06C74.429 8.52924 86.6431 14.1827 100.544 14.1827C114.446 14.1827 126.66 8.52925 133.638 5.91746e-06L184.608 7.39683e-06Z",
    fill: "#F5A151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.946 308.689C198.946 316.593 192.527 323 184.608 323H133.638C126.66 314.471 114.446 308.817 100.545 308.817C86.6436 308.817 74.4288 314.471 67.4512 323H14.3389C6.41995 323 -3.46147e-07 316.593 0 308.689V99.1884C22.847 128.651 58.5855 147.616 98.7549 147.616C139.776 147.616 176.177 127.84 198.946 97.3017V308.689Z",
    fill: "url(#paint0_linear_9_162)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_162",
    x1: 60.9956,
    y1: 252.18,
    x2: 202.593,
    y2: 136.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D96900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselTicketBg2);
export default __webpack_public_path__ + "static/media/carousel_ticket_bg2.1d22c1e52d9b893457cfe31e2a52ec11.svg";
export { ForwardRef as ReactComponent };